import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let InvalidGoods = class InvalidGoods extends Vue {
    created() { }
};
tslib_1.__decorate([
    Prop({ default: () => { } })
], InvalidGoods.prototype, "invalidPro", void 0);
InvalidGoods = tslib_1.__decorate([
    Component({
        filters: {
            filterReason: v => {
                if (v.includes('下架')) {
                    return '已下架';
                }
                else if (v.includes('售罄')) {
                    return '已售罄';
                }
                else if (v.includes('限购')) {
                    return '限购';
                }
                else {
                    return '已失效';
                }
            },
        },
    })
], InvalidGoods);
export default InvalidGoods;
